// extracted by mini-css-extract-plugin
module.exports = {"btn":"_3Ecm_173VbbA7LcdH3BeTZ"};